function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isArray } from '../type';
export var emptyArray = function emptyArray() {
  return [];
};
export var createArray = function createArray(length, createItem) {
  var array = Array(length);

  for (var index = 0; index < length; index++) {
    array[index] = createItem(index);
  }

  return array;
};
export var firstItem = function firstItem(array) {
  return array[0];
};
export var lastItem = function lastItem(array) {
  return array[array.length - 1];
};
export var arrayEqual = function arrayEqual(arrayA, arrayB) {
  if (arrayA === arrayB) {
    return true;
  }

  if (arrayA.length !== arrayB.length) {
    return false;
  }

  var length = arrayA.length;

  for (var i = 0; i < length; i++) {
    if (arrayA[i] !== arrayB[i]) {
      return false;
    }
  }

  return true;
};
export function createArrayEqual(equal) {
  return function arrayEqual(arrayA, arrayB) {
    if (arrayA === arrayB) {
      return true;
    }

    if (arrayA.length !== arrayB.length) {
      return false;
    }

    var length = arrayA.length;

    for (var i = 0; i < length; i++) {
      if (!equal(arrayA[i], arrayB[i])) {
        return false;
      }
    }

    return true;
  };
}
export var deDupe = function deDupe(array) {
  var result = [];

  for (var i = 0; i < array.length; i++) {
    if (!result.includes(array[i])) {
      result.push(array[i]);
    }
  }

  return result;
};
export function createDeDupe(equal) {
  return function deDupe(array) {
    var result = [];

    var _loop = function _loop(i) {
      var element = array[i];

      if (!result.some(function (cur) {
        return equal(cur, element);
      })) {
        result.push(element);
      }
    };

    for (var i = 0; i < array.length; i++) {
      _loop(i);
    }

    return result;
  };
}
export var deDupe2D = createDeDupe(arrayEqual);
export var arrayMatch = function arrayMatch(arrayA, arrayB) {
  if (arrayA === arrayB) {
    return true;
  }

  if (arrayA.length > arrayB.length) {
    return false;
  }

  var length = arrayA.length;

  for (var i = 0; i < length; i++) {
    if (arrayA[i] !== arrayB[i]) {
      return false;
    }
  }

  return true;
};
export var isArray2D = function isArray2D(value) {
  return isArray(value) && value.every(isArray);
};
export var ensureArray = function ensureArray(value) {
  return isArray(value) && value || [value];
};
export var ensureArray2D = function ensureArray2D(value) {
  return (isArray(value[0]) || value.length === 0) && value || [value];
};
var Condition;

(function (Condition) {
  Condition[Condition["Smaller"] = -1] = "Smaller";
  Condition[Condition["Unlimited"] = 0] = "Unlimited";
  Condition[Condition["Bigger"] = 1] = "Bigger";
})(Condition || (Condition = {}));

export var closestItem = function closestItem(arr, num) {
  var condition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Condition.Unlimited;
  var ret = num;
  var distance = Infinity;

  for (var i = 0; i < arr.length; i++) {
    var newDistance = Math.abs(arr[i] - num);

    if (newDistance < distance) {
      switch (condition) {
        case Condition.Smaller:
          if (arr[i] < num) {
            distance = newDistance;
            ret = arr[i];
          }

          break;

        case Condition.Bigger:
          if (arr[i] > num) {
            distance = newDistance;
            ret = arr[i];
          }

          break;

        default:
          distance = newDistance;
          ret = arr[i];
          break;
      }
    }
  }

  return ret;
};
export var checkArrayChanges = function checkArrayChanges() {
  var previous = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var unchanging = [];
  var additions = [];
  var preMap = new Map(previous.map(function (item) {
    return [item, true];
  }));
  next.map(function (v) {
    if (preMap.delete(v)) {
      unchanging.push(v);
    } else {
      additions.push(v);
    }
  });
  return {
    additions: additions,
    deletions: Array.from(preMap.keys()),
    unchanging: unchanging
  };
};
export var flat = function flat(arr) {
  if (!isArray(arr)) {
    return arr;
  }

  var res = [];
  arr.map(function (item) {
    if (isArray(item)) {
      res.push.apply(res, _toConsumableArray(flat(item)));
    } else {
      res.push(item);
    }
  });
  return res;
};
export var cutArray = function cutArray(arr, num) {
  var res = [];
  arr.forEach(function (v, i) {
    var row = Math.floor(i / num);
    var col = i % num;
    var rowList = res[row] || [];
    rowList.push(v);
    col === 0 && (res[row] = rowList);
  });
  return res;
};